import React from 'react';
import styles from './index.module.scss';
import { useTranslation } from "react-i18next";
import { CompanyPage } from '../../../../hooks/slices/companySlice';
import { WinRateGraph } from './components/WinRateGraph';
import { LotValueGraph } from './components/LotValueGraph';
import { ExperienceGraph } from './components/ExperienceGraph';
import { OrientationGraph } from './components/OrientationGraph';

export interface TabPanelStatisticsProps {
  companyPage: CompanyPage | null;
}

export const TabPanelStatistics: React.FC<TabPanelStatisticsProps> = ({
  companyPage
}) => {
  const { t } = useTranslation();

  if (!companyPage) return <></>;

  const showWinRateGraph: boolean = companyPage.percentageOfBidsWon ? true : false;
  const showLotValueGraph: boolean = companyPage.averageBidValue ? true : false;
  const showExperienceGraph: boolean = companyPage.bids ? true : false;
  const showOrientationGraph: boolean = companyPage.percentageOfLotsThatOnlyDependOnPrice ? true : false;

  return (
    <div className={styles.container}>
      {showWinRateGraph && <WinRateGraph companyPage={companyPage}/>}
      {showLotValueGraph && <LotValueGraph companyPage={companyPage}/>}
      {showExperienceGraph && <ExperienceGraph bids={companyPage.bids}/>}
      {showOrientationGraph && <OrientationGraph companyPage={companyPage}/>}
    </div>
  );
};